<template>
    <div class="availability-overview-mask" @click="onClick"></div>
</template>
<script setup lang="ts">
    import {navbarEventBus} from '@navbar/public-api';
    import {onMounted, onBeforeUnmount} from '#imports';
    import {useInfosRequest} from '~/composables/useInfosRequest';
    import {useProfileStore} from '~/store/profileStore';

    function onClick() {
        navbarEventBus.emit('open-availibility-dialog', {source: 'profile_page'});
    }

    onMounted(() => {
        navbarEventBus.on('availability-navbar:update', refreshAvailability);
    });
    onBeforeUnmount(() => {
        navbarEventBus.off('availability-navbar:update', refreshAvailability);
    });
    const profileStore = useProfileStore();
    const profileStoreRequest = useInfosRequest();
    async function refreshAvailability() {
        await profileStore.getProfile(profileStoreRequest);
    }
</script>
<style scoped lang="scss">
    .availability-overview-mask {
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>
